import { FC, PropsWithChildren } from "react";

import { type LinkWrapperProps } from "@jti/ui/providers/LinkBehaviourContext";

import { Link } from "@/libs/i18n";

export const NextLinkWrapper: FC<PropsWithChildren<LinkWrapperProps>> = ({
  children,
  href,
  ...props
}) => {
  if (!href) {
    console.error("href is required for link");
    return <a {...props}>{children}</a>;
  }
  return (
    <Link href={href} {...props}>
      {children}
    </Link>
  );
};
